export const practiceMarkets = [
  { city: "El Paso", detail: "Engineering, Operations & Sales" },
  { city: "Dallas", detail: "Business Development & Project Leadership" },
  { city: "Austin", detail: "Projects by Appointment" },
  { city: "New York", detail: "Projects by Appointment" },
  { city: "Los Angeles", detail: "Projects by Appointment" },
  { city: "Miami", detail: "Projects by Appointment" },
  { city: "Mexico City", detail: "Projects by Appointment" },
] as const;

export const labsLocations = [
  { city: "El Paso", detail: "Private Visits" },
  { city: "Dallas", detail: "Coming Soon" },
] as const;